import { TrackerBean, TrackerControllerApi, ItemResponseTrackerBeanObject, ListResponseTrackerBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class TrackerApi extends BaseApi {
    api: TrackerControllerApi

    constructor() {
        super()
        this.api = new TrackerControllerApi(configuration, configuration.basePath, this.fetch)
    }

    async list(size: number = 20, page: number = 1, sort, search, active): Promise<ListResponseTrackerBean> {
        return this.call(() => this.api.trackerList(search, active, { query: { size, page, sort } }))
    }

    async all(): Promise<ListResponseTrackerBean> {
        return this.call(() => this.api.trackerList())
    }

    async create(tracker: TrackerBean): Promise<ItemResponseTrackerBeanObject> {
        return this.call(() => this.api.createTracker(tracker))
    }

    async edit(id: any, tracker: TrackerBean): Promise<ItemResponseTrackerBeanObject> {
        return this.call(() => this.api.editTracker(tracker, id))
    }

    async view(id: any): Promise<ItemResponseTrackerBeanObject> {
        return this.call(() => this.api.tracker(id))
    }

    async delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteTracker(id))
    }

    async activate(id: any): Promise<void> {
        return this.call(() => this.api.activateTracker(id))
    }
}

const trackerApi = new TrackerApi()
export default trackerApi



// WEBPACK FOOTER //
// ./src/component/app/tracker/TrackerApi.ts